import { Checkbox } from '@src/helpers/Formik/formikAntdCompat'
import styled from 'styled-components'

export const StyledCheckbox = styled(Checkbox)`
  margin-top: 3.5em;
`
